module.exports = __webpack_public_path__ + "img/rainy2.d55cbac2.png";